<div class="row g-0">
    <div class="col">
        <% if (loading) { %>
            <div class="text-center text-dim" style="margin-top:210px;">
                <i class="fa fa-5x fa-circle-notch mb-4 fa-spin text-primary"></i>
                <h3>Előnézet előállítása</h3>
                <p>Néhány pillanat múlva megjelenik a számlakép...</p>
            </div>
		<% } else if (document) { %>
        	<iframe src="data:<%- document.mime_type %>;base64,<%- document.data %>" id="cloud-invoice-preview" style="display:block; width:100%; height:calc(100vh - 255px);"></iframe>
        <% } else { %>
            <div class="text-center text-dim" style="margin-top:210px;">
                <i class="fa fa-5x fa-times-circle mb-4 text-warning"></i>
                <h3>Előnézet nem elérhető</h3>
                <p>Nem sikerült letölteni a fájlt, vagy az hibákat tartalmaz.</p>
            </div>
        <% } %>
    </div>
</div>